import _ from 'lodash';
import codecs from './codecs';
import { isValidLeanType, isYupMetadataLeanSchema } from './utils';
const removeExplicitUndefined = (obj) => _.pickBy(obj, e => e !== undefined);
const validateSchema = (key, schema) => {
    const metadata = schema.meta();
    if (!isYupMetadataLeanSchema(metadata)) {
        throw new Error(`invalid schema metadata object for prop ${key} (got: ${JSON.stringify(metadata)})`);
    }
    const { leanSchema } = metadata;
    if (!isValidLeanType(leanSchema.type)) {
        throw new Error(`unsupported schema type ${leanSchema.type} for property '${key}'`);
    }
    return leanSchema;
};
export const fromYup = (propsObject) => {
    return Object.entries(propsObject).reduce((acc, [key, schema]) => {
        var _a;
        const { type } = validateSchema(key, schema);
        const codec = codecs[type];
        const required = schema.describe().tests.some(t => t.name === 'required');
        const mobileConfigurable = schema.meta().mobileConfigurable ? true : false;
        const _default = schema.default();
        const optionalData = removeExplicitUndefined(Object.assign({ default: _default }, (_a = codec.extractAdditionalData) === null || _a === void 0 ? void 0 : _a.call(codec, schema)));
        acc[key] = Object.assign({ type, required: required || _default === undefined, mobileConfigurable }, optionalData);
        return acc;
    }, {});
};
//# sourceMappingURL=leanSchemaTransformer.js.map